var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg005Megaphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.003 59.003",
    style: {
      enableBackground: "new 0 0 59.003 59.003"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_66_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    style: {
      fill: "#2D3039"
    },
    d: "M4,30.952H2.211C0.99,30.952,0,29.962,0,28.741v-5.578 c0-1.221,0.99-2.211,2.211-2.211H4V30.952z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    style: {
      fill: "#E74C3D"
    },
    d: "M20.052,35.103L6.648,34.288c-1.463-0.104-2.597-1.321-2.597-2.788V20.365 c0-1.275,0.985-2.332,2.256-2.423l13.744-0.839V35.103z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_115_",
    style: {
      fill: "#ECF0F1"
    },
    d: "M41.998,48.076l-19.634-9.817c-1.417-0.709-2.313-2.157-2.313-3.741V17.607 c0-1.542,0.849-2.959,2.208-3.687L41.894,3.402c2.787-1.493,6.158,0.526,6.158,3.686v37.246 C48.052,47.444,44.779,49.467,41.998,48.076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    style: {
      fill: "#E74C3D"
    },
    d: "M49,20.952h-1v10h1c2.2,0,4-1.8,4-4v-2C53,22.752,51.2,20.952,49,20.952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    style: {
      fill: "#D1D4D2"
    },
    d: "M55.999,32.952c-0.201,0-0.405-0.061-0.582-0.187 c-0.448-0.322-0.552-0.947-0.229-1.396c0.566-0.79,1.877-2.897,1.813-5.391c-0.05-1.976-0.661-3.809-1.817-5.45 c-0.318-0.452-0.21-1.075,0.241-1.393c0.451-0.318,1.076-0.21,1.394,0.241c1.388,1.97,2.122,4.174,2.183,6.551 c0.08,3.098-1.503,5.653-2.188,6.608C56.617,32.807,56.311,32.952,55.999,32.952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    style: {
      fill: "#C03B2B"
    },
    d: "M8.052,34.376v3.577h3c0.552,0,1,0.447,1,1c0,0.552-0.448,1-1,1h-3v2h3 c0.552,0,1,0.447,1,1c0,0.552-0.448,1-1,1h-3v2h3c0.552,0,1,0.447,1,1c0,0.552-0.448,1-1,1h-3v2h3c0.552,0,1,0.447,1,1 c0,0.552-0.448,1-1,1h-3v0.65c0,1.925,1.575,3.5,3.5,3.5s3.5-1.575,3.5-3.5V34.812L8.052,34.376z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_111_",
    style: {
      fill: "#E74C3D"
    },
    d: "M12.052,50.952c0-0.553-0.447-1-1-1h-3v2h3 C11.604,51.952,12.052,51.505,12.052,50.952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    style: {
      fill: "#E74C3D"
    },
    d: "M12.052,46.952c0-0.553-0.447-1-1-1h-3v2h3 C11.604,47.952,12.052,47.505,12.052,46.952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    style: {
      fill: "#E74C3D"
    },
    d: "M12.052,42.952c0-0.553-0.447-1-1-1h-3v2h3 C11.604,43.952,12.052,43.505,12.052,42.952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    style: {
      fill: "#E74C3D"
    },
    d: "M12.052,38.952c0-0.553-0.447-1-1-1h-3v2h3 C11.604,39.952,12.052,39.505,12.052,38.952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    style: {
      fill: "#556180"
    },
    d: "M41.842,3.402L40,4.389v42.714l1.947,0.973C44.728,49.467,48,47.445,48,44.335 V7.089C48,3.928,44.628,1.909,41.842,3.402"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M30.896,14.509c-0.245-0.494-0.842-0.699-1.34-0.453l-4.451,2.201 C23.807,16.952,23,18.299,23,19.773v2.179c0,0.553,0.447,1,1,1s1-0.447,1-1v-2.179c0-0.735,0.402-1.407,1.021-1.738l4.423-2.186 C30.938,15.604,31.142,15.004,30.896,14.509"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M24,23.952c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1s1-0.447,1-1v-2 C25,24.4,24.553,23.952,24,23.952"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg005Megaphone);
export default __webpack_public_path__ + "static/media/005-megaphone.2782f188b4888aa191fa76a42e64810c.svg";
export { ForwardRef as ReactComponent };